module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content background-slider has-text-centered"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7367fd77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/ui/background_slider.vue
// module id = 636
// module chunks = 30